import get from "lodash/get";

import {
  FETCH_ORG_PREFERENCES_SUCCESS,
  FETCH_ORG_PREFERENCES_LOADING,
  FETCH_ORG_PREFERENCES_FAILED
} from "../actionTypeConstants/orgPreferences";

const initialState = {
  orgPreferences: {
    isLoading: false,
    automationApiHost: null,
    automationLogsHost: null,
    automationMediaHost: null,
    automationSentinelHost: null,
    PublicResourceSharingDisabled: null
  }
};

export default function reducer(state = initialState, action = {}) {
  const automationLogsHost = get(
    action,
    ["result", "data", "AUTOMATION_LOGS_HOST"],
    process.env.REACT_APP_AUTOMATION_LOGS_HOST ||
      window?._env_?.REACT_APP_AUTOMATION_LOGS_HOST ||
      null
  );
  const automationMediaHost = get(
    action,
    ["result", "data", "AUTOMATION_MEDIA_HOST"],
    process.env.REACT_APP_AUTOMATION_MEDIA_HOST ||
      window?._env_?.REACT_APP_AUTOMATION_MEDIA_HOST ||
      null
  );
  const automationSentinelHost = get(
    action,
    ["result", "data", "SENTINEL_HOST"],
    process.env.REACT_APP_SENTINEL_HOST ||
      window?._env_?.REACT_APP_SENTINEL_HOST ||
      null
  );
  const webrtcHost = get(
    action,
    ["result", "data", "WEBRTC_SIGNAL_HOST"],
    process.env.REACT_APP_HYP_LIVE_VIDEO ||
      window?._env_?.REACT_APP_HYP_LIVE_VIDEO ||
      null
  );

  const automationApiHost = get(
    action,
    ["result", "data", "LTMS_API_HOST"],
    process.env.REACT_APP_LTMS_API_HOST ||
      window?._env_?.REACT_APP_LTMS_API_HOST ||
      null
  );

  const publicResourceSharingDisabled = get(
    action,
    ["result", "data", "PublicResourceSharingDisabled"],
    false
  );

  switch (action.type) {
    case FETCH_ORG_PREFERENCES_LOADING: {
      return {
        ...state,
        orgPreferences: {
          ...state.orgPreferences,
          isLoading: true
        }
      };
    }

    case FETCH_ORG_PREFERENCES_SUCCESS: {
      return {
        ...state,
        orgPreferences: {
          ...state.orgPreferences,
          isLoading: false,
          automationApiHost: automationApiHost,
          automationLogsHost: automationLogsHost,
          automationMediaHost: automationMediaHost,
          automationSentinelHost: automationSentinelHost,
          webrtcHost,
          publicResourceSharingDisabled
        }
      };
    }

    case FETCH_ORG_PREFERENCES_FAILED: {
      return {
        ...state,
        orgPreferences: {
          ...state.orgPreferences,
          isLoading: false,
          error: action.error
        }
      };
    }

    default:
      return state;
  }
}
